export default "__VITE_ASSET__2cab5806__"